import { css } from "lit";
export const linkStyles = css `
  a {
    font-family: var(
      --wh-typography-font-family,
      "Source Sans Pro",
      helvetica,
      arial
    );
    padding-left: 1px;
    padding-right: 1px;
    font-style: normal;
    font-weight: 500;
    font-size: var(--wh-font-size-medium, 16px);
    line-height: var(--wh-dimension-spacer-s, 24px);
    text-align: center;
    text-decoration-line: underline;

    /* Accent/Interactive */
    color: var(--wh-theme-colors-primary, #284b9b);
  }
`;
